import { SelectOption } from '../models/select.model';

export enum Meal {
  BREAKFAST = 1,
  BREAKFAST_PARKING,
  DINNER,
  DINNER_BREAKFAST,
  DINNER_PARKING,
  DINNER_WIFI,
  DINNER_BREAKFAST_PARKING,
  DINNER_BREAKFAST_WIFI,
  DINNER_BREAKFAST_WIFI_PARKING,
  PARKING,
  PARKING_WIFI,
  WIFI,
}

export const mealSelectOptions: SelectOption[] = Object.keys(Meal)
  .filter((meal: string) => !(parseInt(meal) >= 0))
  .map((meal: string) => ({
    label: meal
      .toLowerCase()
      .split('_')
      .map((value) => value[0].toUpperCase() + value.substring(1))
      .join(' + '),
    value: Meal[meal],
  }));
